export default __webpack_public_path__ + "images/0fa21ae6afefa3380dbd215a8966e2b0.svg";